import React from 'react';
import classnames from 'classnames';
import { BiLink, BiEventType } from '../../../../biLogger';
import s from './Facets.scss';
export var Facets = function (_a) {
    var contentFacet = _a.contentFacet, categoryFacet = _a.categoryFacet, typeFacet = _a.typeFacet, className = _a.className;
    if (!(categoryFacet || typeFacet || contentFacet)) {
        return null;
    }
    var facetsWithName = [
        [typeFacet, 'facet_type'],
        [contentFacet, 'facet_content'],
        [categoryFacet, 'facet_category'],
    ];
    return (React.createElement("div", { className: classnames(s['root'], className) }, facetsWithName.map(function (_a) {
        var facet = _a[0], facetName = _a[1];
        return facet && (React.createElement(BiLink, { className: s['facet'], key: facet.urlFragment, href: facet.linkTo, biData: {
                evid: BiEventType.FACET_CLICK,
                link_url: facet.linkTo,
                facetname: facetName,
                facetitem: facet.displayNameEn,
            } }, facet.displayNameEn));
    })));
};
Facets.displayName = 'Facets';
export default Facets;
//# sourceMappingURL=Facets.js.map